// @ts-strict-ignore
import { ArticleContainer } from '../model3d/article-container';
import { CustomImageDataVO } from '@project/components/article/model/vo/custom-article.vo';

export class ImageProcessingData {
  public userId: number;
  public customImageHash: string;
  public articleContainer: ArticleContainer;
  public customImageData: CustomImageDataVO;

  constructor(userId: number, customImageHash: string, articleContainer: ArticleContainer, customImageData: CustomImageDataVO = null) {
    this.userId = userId;
    this.customImageHash = customImageHash;
    this.articleContainer = articleContainer;
    this.customImageData = customImageData;
  }
}
